import { render, staticRenderFns } from "./TtService.vue?vue&type=template&id=a61e22f4"
import script from "./TtService.vue?vue&type=script&lang=ts"
export * from "./TtService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports